export default __webpack_public_path__ + "static/media/pantallagrande.e9be08dd.png";